/************************************
MODULE:         Popup map module
WHAT IT DOES:   loads Google map in popup modal after user interaction
*************************************/
(function(root, factory) {
  if (typeof define === 'function' && define.amd) {
      define(['jquery'], factory);
  } else if (typeof exports === 'object') {
      module.exports = factory(require('jquery'));
  } else {
      root.returnExports = factory(root.jQuery);
  }
})(this, function($) {
  var isScriptLoaded = false,
      isMapLoaded = false,
      mapCallbacks = [],
      key = '',
      lang = '',
      region = '',
      mapPopup = null,
      mapPopupModal = null,
      mapEl = null,
      mapTrigger = null,
      mapCloseButton = null,
      tabCloseButton = null,
      tween = null;

  function init() {
    mapPopup = document.querySelector('.js-map-popup:not(.js-inited)');
    if (!mapPopup) return;

    mapEl = mapPopup.querySelector('.js-popup-map:not(.js-inited)');
    if (!mapEl) return;

    key = mapEl.dataset.key || '';
    lang = mapEl.dataset.lang || '';
    region = mapEl.dataset.region || '';

    require('tweenmax');

    mapPopupModal = mapPopup.querySelector('.js-map-popup-modal');

    addListeners();
  }

  function addListeners() {
    mapTrigger = mapPopup.querySelector('.js-map-popup-trigger');
    mapCloseButton = mapPopup.querySelector('.js-map-popup-close');
    tabCloseButton = mapPopup.querySelector('.js-map-popup-tab-close');

    if (!mapTrigger) return;

    mapTrigger.addEventListener('click', openPopup);
    mapCloseButton.addEventListener('click', closePopup);
    tabCloseButton.addEventListener('click', closePopup);
  }

  function openPopup(e) {
    e.preventDefault();

    tweenPromote(tween);
    tween = new TimelineMax();
    tween.to(mapPopupModal, 0.0, { visibility: "visible", display: "block" });
    tween.to(mapPopupModal, 0.5, { opacity: 1 });
    tween.play();

    mapTrigger.setAttribute('aria-expanded', 'true');
    $('html').addClass('simple-popup-opened');

    document.addEventListener('keydown', handleKeyDownEvent);

    initMap();
  }

  function closePopup(e) {
    if (e) e.preventDefault();

    document.removeEventListener('keydown', handleKeyDownEvent);

    tweenPromote(tween);
    tween = new TimelineMax({onComplete: closeAnimationEnd});
    tween.to(mapPopupModal, 0.5, { opacity: 0 });
    tween.to(mapPopupModal, 0.0, { visibility: "hidden", display: "none" });
    tween.play();
  }

  function closeAnimationEnd() {
    mapTrigger.setAttribute('aria-expanded', 'false');
    $('html').removeClass('simple-popup-opened');
  }

  function initMap() {
      var map = $('.js-popup-map').not('.js-inited');

      if (!map.length) return;

      var googleMapsLoadDelay = window.App.globals.googleMapsLoadDelay;
      var delay = !isNaN(Number(googleMapsLoadDelay)) ? Number(googleMapsLoadDelay) : 0;

      setTimeout(function() {
          if (typeof window.gmapInitialize == 'undefined' || !isMapLoaded) {
              loadScript(initialize.bind(this));
          } else {
              initialize();
          }
      }, delay);
  }

  function loadScript(callback) {
      mapCallbacks.push(callback);

      if (isScriptLoaded === true) {
          return;
      }

      isScriptLoaded = true;

      mapscript = document.createElement('script');
      mapscript.type = 'text/javascript';
      mapscript.async = true;
      mapscript.src =
          'https://maps.googleapis.com/maps/api/js?v=3' +
          '&callback=gmapInitialize&key=' + key;
      
          if (lang !== '') {
        mapscript.src + '&language=' + lang;
      }

      if (region !== '') {
        mapscript.src + '&region=' + region;
      }

      window.gmapInitialize = onScriptLoaded;
      document.body.appendChild(mapscript);
  }

  function onScriptLoaded() {
      isMapLoaded = true;
      for (var i = 0, l = mapCallbacks.length; i < l; i++) {
          mapCallbacks[i]();
      }
  }

  function initialize() {
      window.onStyleLoaded.subscribe(function () {
          if (typeof window.google == 'undefined') return;

         require.ensure([], function () {
          var map = $('.js-popup-map').not('js-inited');
          var genericmap = require('generic.map');

          map.addClass('js-inited');

          for (var i = 0, l = map.length; i < l; i++) {
              var mapSingle = map.eq(i),
                  settings = {},
                  dataAttributes = mapSingle.data();

              for (var attr in dataAttributes) {
                  settings[attr] = dataAttributes[attr];
              }

              new genericmap(map, settings);
          }
      }, 'map');

      });
  }

  function handleKeyDownEvent(e) {
    var isTabPressed = e.key === 'Tab' || e.keyCode === 9;
    var isEscPressed = e.key === 'Escape' || e.keyCode == 27; 

      if (!isTabPressed && !isEscPressed) {
        return;
      }

      if (isTabPressed) {
        trapFocus(e);
      }
      
      if (isEscPressed) {
        closePopup();
      }
  }

  function trapFocus(e) {
    if (e.shiftKey) {
      if (document.activeElement === mapCloseButton) {
        tabCloseButton.focus();
        e.preventDefault();
      }
      } else {
        if (document.activeElement === tabCloseButton) {
          mapCloseButton.focus();
          e.preventDefault();
        }
      }
  }

  function tweenPromote(tween) {
    if (typeof tween == 'undefined' || tween == null)
        return;

    if (typeof tween.progress == 'function' && tween.progress() < 1) {
        tween.pause();
        tween.progress(1);
    }

    if (typeof tween.destroy == 'function') {
        tween.destroy();
    }
  }

  return {
      init: init
  };
});



/*****************
 ** WEBPACK FOOTER
 ** ./js/app/modules/app.popupmap.js
 ** module id = 50
 ** module chunks = 24
 **/